import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-ops-and-maintain-tree',
  templateUrl: './ops-and-maintain-tree.component.html',
  styleUrls: ['./ops-and-maintain-tree.component.css']
})
export class OpsAndMaintainTreeComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() search: string = '';
  @Input() selectable: boolean = true;
  @Input() editable: boolean = false;
  @Input() singleSelect: boolean = true;
  @Input() selected: Array<string>;
  @Input() elementId: string;
  @Output() change = new EventEmitter();
  @Output() bubble = new EventEmitter();
  localSelectedList = [];
  propertyManager: boolean = false;

  hoverTarget = {
    time: null,
    id: null,
    block: false
  }

  constructor(private sanitize: DomSanitizer, private http: HttpClient) { }

  ngOnInit(): void {
    if (!!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement')) {
      this.propertyManager = true;
    }
  }

  ngOnChanges(c: SimpleChanges) {
    if (!!c && !!c.selected && !!c.selected.currentValue && this.singleSelect && this.localSelectedList.length > 0) {
      if (!this.localSelectedList.includes(this.selected[0])) {
        let item = this.data.find(x => x.items != null && x.items.find(y => y.id == this.localSelectedList[0])).items.find(x => x.id == this.localSelectedList[0]);
        item.selected = false;
        this.localSelectedList = [];
      }
    }
  }

  childChange(child, e) {
    switch (e.change) {
      case ('showMe'): {
        child.showChildren = true;
        child.hidden = false;
        break
      }
      case ('hideMe'): {
        child.showChildren = false;
        child.hidden = true;
        this.change.emit({ change: 'hideMe' })
        break
      }
      case ('unselect'):
      case ('select'): {
        this.change.emit({ change: e.change, id: e.id, account: e.account });
        break;
      }
    }
  }

  addToSelectedList(item, a) {
    // Multiple selections
    if (!this.singleSelect) {
      if (item.selected) {
        this.change.emit({ change: 'select', id: item.id, account: a });
        this.localSelectedList.push(item.id);
      } else {
        this.change.emit({ change: 'unselect', id: item.id, account: a });
        this.localSelectedList = this.localSelectedList.filter(x => x != item.id);
      }
    }
 
    // Single selections
    if (this.singleSelect) {
      if (this.localSelectedList.length > 0) {
        let item = this.data.find(x => !!x.items && x.items.find(y => y.id == this.localSelectedList[0])).items.find(x => x.id == this.localSelectedList[0]);
        item.selected = false;
      }
      let emit = { change: 'select', id: item.id, account: a };
      this.change.emit(emit);
      this.localSelectedList = [item.id];
    }
  }

  catEdit(x) {
    if (!this.editable) {
      x.showChildren = !x.showChildren;
      x.showItems = !x.showItems
    }
    else {
      x.editing = true;
    }
  }

  rename(x) {
    x.editing = false;
    this.bubble.emit(
      {
        type: 'catRename',
        id: x.id,
        parentId: x.parentId,
        name: x.name
      }
    )
  }

  onDragStart(x, type) {
    switch (type) {
      case ('object'): {
        this.bubble.emit(
          {
            type: 'catDragStart',
            id: x.id,
            parentId: x.parentId,
            name: x.name,
            data:x
          }
        )
        ; break
      }
      case ('item'): {
        this.bubble.emit(
          {
            type: 'itemDragStart',
            id: x.id,
            parentId: x.categoryId,
            name: x.data.text,
            data: x
          }
        )
        ; break
      }
    }
    
  }

  onDragEnd(x, type) {
    switch (type) {
      case ('object'): {
        this.bubble.emit(
          {
            type: 'catDragEnd',
            id: x.id,
            parentId: x.parentId,
            name: x.name
          }
        )
        ; break
      }
      case ('item'): {
        this.bubble.emit(
          {
            type: 'itemDragEnd',
            id: x.id,
            parentId: x.parentId,
            name: x.name
          }
        )
        ; break
      }
    }
    
  }

  hoverTime(x, e: boolean) {
    if (this.hoverTarget.id != x.id && e) { this.hoverTarget.id = x.id; this.hoverTarget.time = Date.now() }
    if (Date.now() > this.hoverTarget.time + 1000 && !this.hoverTarget.block) {
      x.showChildren = true;
      x.showItems = true;
      this.bubble.emit({
        type: 'showChild',
        data: x
      })
      this.hoverTarget.block = true;
    }
    if (!e) { this.hoverTarget = {time:null, id: null, block: false} }
  }

  showChild(x) {
    x.showChildren = !x.showChildren;
    x.showItems = !x.showItems;
    this.bubble.emit({
      type: 'showChild',
      data: x
    })
  }

  bubbler(x) {
    this.bubble.emit(x)
  }

  onBlur(x) {
    x.editing = false;
  }

  onDragStop(e) {
    let el = document.getElementById(this.elementId).getBoundingClientRect();
    if (e.clientX < el.left || e.clientX > el.right || e.clientY < el.top || e.clientY > el.bottom) {
      this.bubble.emit(
        {
          type: 'catDragEnd',
          id: null,
          parentId: null,
          name: null
        }
      )
    }
  }

  textReplacer(text){
    let i = text.toLowerCase().indexOf(this.search.toLowerCase());
    return text.slice(0,i) + '<b style="text-decoration: underline;">' + text.slice(i, this.search.length + i) + '</b>' + text.slice(this.search.length + i);
  }

  editItem(event, item, name) {
    item.data[name] = event;
    let i = this.data.find(x => x.id == item.categoryId).items.find(x => x.id == item.data.id);
    this.updateAccountPlan(i.data);
  }

  editCategory(event, item) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/AddDVCategory/' + item.id, { name: event, parentId: item.parentId }, { headers }).subscribe({
      error: err => console.error(err),
    });
  }

  updateAccountPlan(x) {
    let data = {
      categoryId: x.categoryId,
      commonCost: x.commonCost,
      parentId: x.parentId,
      propertyCost: x.propertyCost,
      subscription: x.subscription,
      text: x.text,
      title: x.title
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Activity/EditAccountPlan/' + x.id, data, { headers }).subscribe({
      error: err => console.error(err)
    });
  }

  deleteAccountPlan(x) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.delete(api.jubloApi + 'api/Activity/DeleteAccountPlan/' + x.id, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => { 
        this.bubble.emit(
          {
            type: 'accountDeleted',
            id: x.id,
            parentId: null,
            name: null,
            categoryId: x.categoryId
          });
      }
    });
  }
}